import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type ISaveLocationsMutationVariables = Types.Exact<{
  locations: Array<Types.ILocationInput> | Types.ILocationInput
}>

export type ISaveLocationsMutation = {
  saveManyLocations?: Array<{
    id?: any | null
    name: string
    projectId: any
    type?: Types.LocationType | null
    templateId?: string | null
    data?: any | null
  } | null> | null
}

export const SaveLocationsDocument = gql`
  mutation SaveLocations($locations: [LocationInput!]!) {
    saveManyLocations(locations: $locations) {
      id
      name
      projectId
      type
      templateId
      data
    }
  }
`
export type ISaveLocationsMutationFn = Apollo.MutationFunction<
  ISaveLocationsMutation,
  ISaveLocationsMutationVariables
>

/**
 * __useSaveLocationsMutation__
 *
 * To run a mutation, you first call `useSaveLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveLocationsMutation, { data, loading, error }] = useSaveLocationsMutation({
 *   variables: {
 *      locations: // value for 'locations'
 *   },
 * });
 */
export function useSaveLocationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISaveLocationsMutation,
    ISaveLocationsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISaveLocationsMutation,
    ISaveLocationsMutationVariables
  >(SaveLocationsDocument, options)
}
export type SaveLocationsMutationHookResult = ReturnType<
  typeof useSaveLocationsMutation
>
export type SaveLocationsMutationResult =
  Apollo.MutationResult<ISaveLocationsMutation>
export type SaveLocationsMutationOptions = Apollo.BaseMutationOptions<
  ISaveLocationsMutation,
  ISaveLocationsMutationVariables
>
